import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer22 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Chanderi', path: '/template22/collections/chanderi' },
        { label: 'Banarasi', path: '/template22/collections/banarasi' },
        { label: 'Khadi', path: '/template22/collections/khadi' },
        { label: 'Block Print', path: '/template22/collections/block-print' },
        { label: 'Chikankari', path: '/template22/collections/chikankari' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template22/contact' },
        { label: 'Shipping Policy', path: '/template22/shipping-policy' },
        { label: 'Returns & Exchange', path: '/template22/shipping-exchange' },
        { label: 'FAQs', path: '/template22/faqs' },
        { label: 'Track Order', path: '/template22/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#5C3D2E' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="maati-footer-main"
                >
                    <div className="maati-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Cormorant Infant', Georgia, serif",
                                    fontSize: '32px',
                                    fontWeight: 600,
                                    color: '#F3ECE4',
                                    letterSpacing: '5px',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                MAATI
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Cormorant Infant', Georgia, serif",
                                    fontSize: '15px',
                                    color: '#E8DDD0',
                                    lineHeight: 1.7,
                                    margin: '0 0 8px 0',
                                    fontStyle: 'italic',
                                }}
                            >
                                Woven by Hand, Worn with Pride
                            </p>
                            <p
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    color: '#8B7355',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Celebrating India's textile heritage through handcrafted garments that honour artisan traditions.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[
                                    { icon: <Instagram size={18} />, label: 'Instagram' },
                                    { icon: <Facebook size={18} />, label: 'Facebook' },
                                    {
                                        icon: (
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                                <path d="M12 2a10 10 0 1 0 4 19.2" />
                                            </svg>
                                        ),
                                        label: 'Pinterest'
                                    }
                                ].map((social, index) => (
                                    <a
                                        key={index}
                                        href="#"
                                        aria-label={social.label}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            border: '1px solid rgba(232,221,208,0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#C4572A',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#C4572A';
                                            e.currentTarget.style.backgroundColor = 'rgba(196,87,42,0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(232,221,208,0.3)';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        {social.icon}
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#C4572A',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '14px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#E8DDD0',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#C4572A')}
                                            onMouseLeave={(e) => (e.target.style.color = '#E8DDD0')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#C4572A',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '14px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#E8DDD0',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#C4572A')}
                                            onMouseLeave={(e) => (e.target.style.color = '#E8DDD0')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Contact */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#C4572A',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#C4572A', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#E8DDD0',
                                        }}
                                    >
                                        hello@maati.in
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#C4572A', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#E8DDD0',
                                        }}
                                    >
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    {/* WhatsApp SVG icon */}
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#C4572A"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ flexShrink: 0 }}
                                    >
                                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                    </svg>
                                    <span
                                        style={{
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#E8DDD0',
                                        }}
                                    >
                                        Chat with us on WhatsApp
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#C4572A', flexShrink: 0, marginTop: '2px' }} />
                                    <span
                                        style={{
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#E8DDD0',
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        Jaipur, Rajasthan, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Crafted in India Badge */}
                <div style={{ borderTop: '1px solid rgba(232,221,208,0.15)' }}>
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            padding: '24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '16px',
                            }}
                            className="maati-footer-bottom"
                        >
                            <p
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '12px',
                                    color: '#8B7355',
                                    margin: 0,
                                }}
                            >
                                &copy; 2026 MAATI. All rights reserved.
                            </p>

                            {/* Crafted in India Badge */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C4572A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                                    <path d="M2 17l10 5 10-5" />
                                    <path d="M2 12l10 5 10-5" />
                                </svg>
                                <span
                                    style={{
                                        fontFamily: "'Cormorant Infant', Georgia, serif",
                                        fontSize: '14px',
                                        color: '#E8DDD0',
                                        fontStyle: 'italic',
                                    }}
                                >
                                    Crafted in India
                                </span>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                {/* Visa */}
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="rgba(232,221,208,0.1)" stroke="rgba(232,221,208,0.2)" />
                                    <text x="18" y="14" textAnchor="middle" fill="#8B7355" fontSize="8" fontWeight="bold" fontFamily="Source Sans 3, sans-serif">VISA</text>
                                </svg>
                                {/* Mastercard */}
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="rgba(232,221,208,0.1)" stroke="rgba(232,221,208,0.2)" />
                                    <circle cx="15" cy="12" r="5" fill="#8B7355" opacity="0.5" />
                                    <circle cx="21" cy="12" r="5" fill="#8B7355" opacity="0.5" />
                                </svg>
                                {/* UPI */}
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="rgba(232,221,208,0.1)" stroke="rgba(232,221,208,0.2)" />
                                    <text x="18" y="14" textAnchor="middle" fill="#8B7355" fontSize="7" fontWeight="bold" fontFamily="Source Sans 3, sans-serif">UPI</text>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .maati-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .maati-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .maati-footer-main {
                            padding: 40px 24px !important;
                        }
                        .maati-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .maati-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer22;
